export default ['$rootScope', findReplace]

export function findReplace(root) {
  this.init = () => {
    root.$broadcast('FIND_AND_REPLACE', {
      type: 'INIT',
    })
  }

  this.reset = () => {
    root.$broadcast('FIND_AND_REPLACE', {
      type: 'RESET',
    })
  }

  this.terminate = () => {
    root.$broadcast('FIND_AND_REPLACE', {
      type: 'TERMINATE',
    })
  }
}
